if (typeof Billing == 'undefined') Billing = { contextRoot: '/billing' };
"use strict";

Billing.Product = Backbone.AssociatedModel.extend({
    idAttribute: 'uuid',
    urlRoot: Billing.contextRoot + '/product',

    price: function(currentCurrency, currentPeriod) {
        var price = _(this.get('prices')).findWhere({
            currency: currentCurrency,
            period: currentPeriod
        });
        return price && price.amount;
    }
});

Billing.Products = Backbone.Collection.extend({
    model: Billing.Product,
    url: Billing.contextRoot + '/product'
});

Billing.Subscription = Backbone.AssociatedModel.extend({
});

Billing.Price = Backbone.AssociatedModel.extend({
});

Billing.CustomerUser = Backbone.AssociatedModel.extend({
    idAttribute: 'uuid',
    relations: [
        {key: 'subscriptions', type: Backbone.Many, relatedModel: Billing.Subscription},
    ],
    fetchCore: function() {
        var self = this;
        this.fetchCoreRequest = $.getJSON(Core.contextRoot + '/user/'+this.get('uuid'), function (user) {
            self.set('user',user);
        }).complete(function () {
            delete self.fetchCoreRequest;
        });
    },
    toJSON: function() {
        // skip 'user' attribute
        var attrs = _(this.attributes).clone();
        delete attrs.user;
        return attrs;
    }

});

Billing.CustomerUsers = Backbone.Collection.extend({
    model: Billing.CustomerUser
});

Billing.AddableUsers = Core.Users.extend({
    model: Core.User,
    url: Billing.contextRoot + '/user/addable'
});

Billing.Address = Backbone.AssociatedModel.extend({
    validate: function(attrs) {
        var errors = [];
        if (!attrs.company)
            errors.push({ name: 'company', required: true});
        if (!attrs.address1)
            errors.push({ name: 'address1', required: true});
        if (!attrs.postalCode)
            errors.push({ name: 'postalCode', required: true});
        if (!attrs.city)
            errors.push({ name: 'city', required: true});
        if (!attrs.country)
            errors.push({ name: 'country', required: true});
        if (errors.length > 0)
            return errors;
    }
});

Billing.Customer = Backbone.AssociatedModel.extend({
    urlRoot: Billing.contextRoot + '/customer',
    idAttribute: 'uuid',
    relations: [
        {key: 'billingAddress', type: Backbone.One, relatedModel: Billing.Address},
        {key: 'users', type: Backbone.Many, relatedModel: Billing.CustomerUser, collectionType: Billing.CustomerUsers},
        {key: 'subscriptions', type: Backbone.Many, relatedModel: Billing.Subscription},
        {key: 'prices', type: Backbone.Many, relatedModel: Billing.Price},
    ],

    validate: function(attrs) {
        var swedishCustomer = false;
        if (!attrs.editable)
            return;
        var errors = [];
        if (!attrs.name)
            errors.push({ name: 'name', required: true, selector: '#customer-data'});
        if (!attrs.contactName)
            errors.push({ name: 'contactName', required: true, selector: '#customer-data'});
        if (!attrs.contactEmailAddress)
            errors.push({ name: 'contactEmailAddress', required: true, selector: '#customer-data'});
        if (!attrs.paymentMethod)
            errors.push({ name: 'paymentMethod', required: true, selector: '#customer-data'});
        if (attrs.paymentMethod == 'INVOICE' && attrs.billingAddress) { // paymentMethod == 'INVOICE' doesn't really apply anymore but I don't want to change anything :(
            var address = attrs.billingAddress;
            var addressErrors = address.validate(address.attributes);
            swedishCustomer = address.get('country') == 'se';
            if (addressErrors) {
                _(addressErrors).each(function (e) {
                    e.selector = '#address-data';
                });
                errors = errors.concat(addressErrors);
            }
        }
        if (!attrs.orgNumber && swedishCustomer) {
            errors.push({ name: 'orgNumber', required: true, selector: '#customer-data' });
        }
        if (errors.length > 0)
            return errors;
    },

    getAllSubscriptions: function() {
        var subscriptions = [];
        if (this.get('users')) {
            this.get('users').each(function (user) {
                user.get('subscriptions').each(function (subscription) {
                    subscriptions.push(subscription);
                });
            });
        }
        if (this.get('subscriptions')) {
            this.get('subscriptions').each(function (subscription) {
                subscriptions.push(subscription);
            });
        }
        return subscriptions;
    },

    getProductsSummary: function() {
        var prices = {};
        var counts = {};
        var names = {};
        _(this.getAllSubscriptions()).each(function (subscription) {
            var uuid = subscription.get('productUuid') || subscription.get('description');
            var price = typeof subscription.get('amount') == 'number' ? subscription.get('amount') : subscription.get('productAmount');
            var quantity = typeof subscription.get('quantity') == 'number' ? subscription.get('quantity') : 1;
            if (uuid in names) {
                counts[uuid] += quantity;
                prices[uuid] += price;
            } else {
                names[uuid] = subscription.get('productName') || subscription.get('description');
                counts[uuid] = quantity;
                prices[uuid] = price;
            }
        }, this);
        var products = [];
        _(Object.keys(names)).each(function (uuid) {
            products.push({uuid: uuid, name: names[uuid], count: counts[uuid], priceAmount: prices[uuid]});
        }, this);
        return products;
    },

    getTotalPriceAmount: function(ignoreFixedPrice) {

        var subscriptions;
        var total = 0;
        if (this.get('fixedPrice') && !ignoreFixedPrice) {
            total = this.get('fixedPrice');
            subscriptions = this.get('subscriptions').models;
        } else {
            subscriptions = this.getAllSubscriptions();
        }
        _(subscriptions).each(function(subscription) {
            if (!subscription) return;
            var price = typeof subscription.get('amount') == 'number' ? subscription.get('amount') : subscription.get('productAmount');
            var quantity = typeof subscription.get('quantity') == 'number' ? subscription.get('quantity') : 1;
            if (!price || !quantity) return true;
            total += quantity * price;
        }, this);
        return total;
    },

    setUserInfoFromCore: function() {
        if (!this.get('users')) return;
        this.get('users').each(function (customerUser) {
            if (customerUser && customerUser.get('user')) {
                var coreUser = customerUser.get('user');
                customerUser.set({
                    fullName: coreUser.fullName,
                    emailAddress: coreUser.emailAddress,
                });
            }
        }, this);
    },

    price: function(productUuid, currentCurrency, currentPeriod) {
        var price = this.get('prices').findWhere({
            productUuid: productUuid,
            currency: currentCurrency,
            period: currentPeriod
        });
        return price && price.get('amount');
    }
});

Billing.Customers = Backbone.Collection.extend({
    model: Billing.Customer,
    url: Billing.contextRoot + '/customer/all'
});

Billing.Invoice = Backbone.Model.extend({
    urlRoot: Billing.contextRoot + '/invoice',

    initialize: function(options) {
        this.path = options.path;
    },

    url: function() {
        return Billing.Invoice.prototype.urlRoot + (this.path ? '/' + this.path : '');
    },

    getTotalPriceAmount: function() {
        var total = 0;
        _(this.get('items')).each(function(item) {
            var quantity = typeof item.quantity == 'number' ? item.quantity : 1;
            total += quantity * item.amount;
        }, this);
        return total;
    },

});

Billing.Invoices = Backbone.Collection.extend({
    model: Billing.Invoice,

    initialize: function(models, options) {
        this.limit = options.limit;
        this.path = options.path;
    },

    url: function() {
        var params = {};
        if (this.limit) params.limit = this.limit;
        return Billing.Invoice.prototype.urlRoot + (this.path ? '/' + this.path : '') + '?' + $.param(params);
    }
});
